import { PageLoader } from '@/components/ui';

/**
 * Loading fallback for lazy-loaded routes
 *
 * Shows a full-page loading state while route component is being fetched.
 * Uses the PageLoader component for consistent styling.
 */
export const RouteLoading = () => {
    return (
        <PageLoader message="Loading..." />
    );
};

export default RouteLoading;
